import { render } from "./MvtPaymentList.vue?vue&type=template&id=3106d8a8"
import script from "./MvtPaymentList.vue?vue&type=script&lang=js"
export * from "./MvtPaymentList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__